module.exports = __webpack_public_path__ + "static/icon_bsh.4f4f147c.png";